import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UploadService {
    private files: File[] = [];

    public setFiles(files: File[]) {
        this.files = files;
    }

    public getFiles(): File[] {
        return this.files;
    }

    public clear() {
        this.files = [];
    }
}